import { defineModule } from '../types';
import { PLANNED } from './destinations';

/** Placeholders for IA destinations whose modules are next (replace route by route). */
export const plannedModule = defineModule({
  key: 'planned',
  // Every IA destination has its module now; add `createRoute(...)` placeholders here for new ones.
  routes: [],
  nav: PLANNED.map((d) => ({
    key: d.key,
    aliases: d.aliases,
    label: d.label,
    description: d.question,
    icon: d.icon,
    to: d.path,
    section: d.section,
    order: d.order,
    permission: d.permission,
    module: d.module,
  })),
});
